import React from "react";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BreadCrumb from '../components/BreadCrumb';

const About = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb active_page="About" />
                    <div class="inner-container">
                        <h2>About Krisantec</h2>
                        <h3>Technology To Innovation</h3>
                        <p>The future of innovations depends solely on its technological foundations. We focus on innovation and excellence through the adoption of best practices and this is what gives us a competitive niche.</p>
                        <p>We believe it’s just not the idea but execution that makes the ideas happen. Our delivery model involves strategic approaches that align with organization priorities, market dynamics and evolving technologies.</p>

                        <h3>Customer Centric</h3>
                        <p>We don’t fit in a technology to fix a business solution. Personalization is the heart of customer centricity. We focus on delivering client centric innovation and value instead of one size fits all solutions</p>

                        <h3>Process We Follow</h3>
                        <ol>
                            <li>Strategy</li>
                            <li>Prototyping</li>
                            <li>Development</li>
                            <li>Application Testing</li>
                            <li>Deployment</li>
                            <li>Performance Optimization</li>
                            <li>Support & Maintenance</li>
                        </ol>

                        <h3>Time Box Every Element</h3>
                        <p>We prioritize tasks at a fast pace, divide our responsibilities efficiently and revise our processes through sprints and iterations. This prevents product backlogs with consistent efficiency.</p>

                        <h3>Diversity & Inclusion</h3>
                        <p>Our Associates are our brand ambassadors. We believe that diversity that make us even stronger and the diverse background of our Associates adds to the plethora of our point of views.</p>
                        <p>We are a blend of Strategists, Architects, Business Analysts, Designers, Developers & Quality Analyst and this helps us discover best possible methods to provide solutions those fulfils the business requirements of our clients.</p>

                        <h3>Why Chose Us?</h3>
                        <ul>
                            <li>Dedicated Teams</li>
                            <li>Agile</li>
                            <li>On Time Delivery</li>
                            <li>Shorter Release Cycles</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default About;